import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import WP from 'WP';
import api from 'api';
import Glider from 'partials/Glider/Glider';
import { getSeason } from 'views/Activities/SeasonRange';

const ActivityCarousel = (props) => {

    const [adventures, setAdventures] = useState([]);
    const [filteredAdventures, setFilteredAdventures] = useState([]);
    const [season, setSeason] = useState(null);

    useEffect(() => {
        api.adventureFetcher.getAllPublic().then(response => {
            setFilteredAdventures(response.data);
            setAdventures(response.data);
        })
      }, []);

    useEffect(() => {
        onHandleFilterAdventures(season);
    }, [season]);

    const onHandleFilterAdventures = (season) => {
        if(!season) return;
        if(season === 'all')
        {
            setFilteredAdventures(adventures);
            return;
        }
        let filterAdventuresBySeason = adventures.filter(adventure => {
            let adventureSeasons = getSeasonsByAdventureDate(adventure);
            return adventureSeasons.includes(season);
        });
        let sortedAdventuresByDate = sortAdventuresByOrder(filterAdventuresBySeason);
        setFilteredAdventures(sortedAdventuresByDate);
    }

    const onHandleSeasonFilter = (season) => {
        setSeason(season);
    }

    const getSeasonsByAdventureDate = (adventure) => {
        return getSeason(adventure.acf.from_date, adventure.acf.to_date);
    }

    const sortAdventuresByOrder = (adventures) => {
        return adventures.sort((a,b) => a.acf.activity_order - b.acf.activity_order);
    }

    if(adventures && adventures.length) {
        return(
            <Glider 
            data={filteredAdventures} 
            title={props.data.title}
            seasonOverride={props.data.season_override}
            seasons
            season={season}
            handleSeasonFilter={season => onHandleSeasonFilter(season)} />
        )
    }
    return null;
}

const mapStateToProps = state => ({
    adventures: state.adventures.posts[WP.lang] ? state.adventures.posts[WP.lang] : [],
});

const actions = {

};

export default connect(mapStateToProps, actions)(ActivityCarousel);